<template>
  <div
    class="not-found-wrapper row d-flex flex-column justify-content-center align-items-center"
  >
    <b-col
      lg="6"
      md="8"
      sm="10"
      class="d-flex flex-column justify-content-center align-items-center"
    >
      <img :src="require('../../static/img/default/404.svg')" />

      <div class="badge-wrapper text-white text-center">
        Page Not Found
      </div>

      <p class="font-weight-bold text-center py-4" style="width: 70%">
        Halaman yang anda cari tidak ditemukan, coba Reload (CTRL + F5) atau
        tunggu beberapa saat lagi. Jika halaman masih belum buka silahkan
        hubungi administrator
      </p>

      <div class="d-flex flex-row align-items-center">
        <b-button variant="primary" @click="reloadPage" class="mr-3">
          <i class="ri-refresh-line"></i>
          Refresh
        </b-button>
        <b-button variant="light" @click="mainPage">
          Kembali ke Halaman Utama
        </b-button>
      </div>
    </b-col>
  </div>
</template>

<style scoped>
.badge-wrapper {
  background: #ec3e51;
  border-radius: 20px;
  font-weight: bold;
  padding: 0.5em 2em;
  font-size: 1.4em;
  margin: 1em auto;
}
.not-found-wrapper {
  min-height: 100vh;
}

.not-found-wrapper img {
  width: 100%;
}

p {
  border-bottom: 1px solid gray;
  margin-bottom: 1em;
}
</style>

<script>
export default {
  name: "not-found-page",
  data() {
    return {};
  },

  methods: {
    reloadPage() {
      window.location.reload();
    },

    mainPage() {
      this.$router.replace("/");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/default-page/not-found.vue